import React from 'react';
import { TabGridContianer } from './adminNameDetailTab.styled';
import AdminNameDetailTabList from './adminNameDetailTab';

const AdminNameDetailTabListContainer = ({
    accountDetailTabList,
    tabActiveId,
    tabSwitch,
}) => {
    return (
        <>
            <TabGridContianer>
                {accountDetailTabList.map((accountTab) => {
                    return (
                        <AdminNameDetailTabList
                            key={accountTab.id}
                            label={accountTab.label}
                            id={accountTab.id}
                            isTabActive={tabActiveId === accountTab.id}
                            tabSwitch={tabSwitch}
                        />
                    );
                })}
            </TabGridContianer>
        </>
    );
};

export default AdminNameDetailTabListContainer;
